module.exports = __webpack_public_path__ + "img/152.google.3be42f77.svg";